export default __webpack_public_path__ + "static/media/DPE_VIERGE.075a6313.png";